import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { AdminBottomNav } from './AdminBottomNav';
import { AdminSectionNav } from './AdminSectionNav';
import { useSidebar } from '@/hooks/useSidebar';
import { cn } from '@/lib/utils';

export function AdminLayout() {
    const { pathname } = useLocation();
    const {
        collapsed,
        toggle,
        isMobile,
        mobileOpen,
        toggleMobile,
        closeMobile,
    } = useSidebar();

    useEffect(() => {
        closeMobile();
    }, [pathname, closeMobile]);

    useEffect(() => {
        if (!mobileOpen) return;
        function onKeyDown(e: KeyboardEvent) {
            if (e.key === 'Escape') closeMobile();
        }
        document.addEventListener('keydown', onKeyDown);
        return () => document.removeEventListener('keydown', onKeyDown);
    }, [mobileOpen, closeMobile]);

    return (
        <div
            className={cn(
                'bg-background overflow-x-hidden',
                isMobile ? 'h-dvh max-h-dvh overflow-hidden' : 'min-h-screen',
            )}
        >
            {isMobile && mobileOpen && (
                <button
                    type="button"
                    aria-label="Cerrar menú"
                    className="fixed inset-0 z-30 bg-black/50 backdrop-blur-[2px] animate-in fade-in duration-200"
                    onClick={closeMobile}
                />
            )}

            <Sidebar
                collapsed={collapsed}
                onToggle={toggle}
                isMobile={isMobile}
                mobileOpen={mobileOpen}
                onMobileClose={closeMobile}
            />
            <TopBar
                collapsed={collapsed}
                isMobile={isMobile}
            />

            <main
                className={cn(
                    'transition-sidebar',
                    isMobile
                        ? 'h-full overflow-y-auto overflow-x-hidden pl-0'
                        : cn(
                            'pt-[var(--topbar-height)] min-h-screen',
                            collapsed
                                ? 'pl-[var(--sidebar-collapsed-width)]'
                                : 'pl-[var(--sidebar-width)]'
                        )
                )}
                style={isMobile ? {
                    paddingTop: 'calc(var(--topbar-height) + var(--safe-area-top))',
                    paddingBottom: 'calc(var(--bottom-nav-height) + var(--safe-area-bottom))',
                    paddingLeft: 'var(--safe-area-left)',
                    paddingRight: 'var(--safe-area-right)',
                    WebkitOverflowScrolling: 'touch',
                } : undefined}
            >
                <div className="p-4 sm:p-6 lg:p-8 max-w-[1600px] mx-auto animate-fade-in w-full min-w-0">
                    <AdminSectionNav />
                    <Outlet />
                </div>
            </main>
            {isMobile ? (
                <AdminBottomNav moreOpen={mobileOpen} onToggleMore={toggleMobile} />
            ) : null}
        </div>
    );
}
